import {
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
import * as React from 'react';

import { SelectButton } from '@/components/SelectButton';
import { AdminEventsInput_Filter_HostedIn } from '@/graphql-types/globalTypes';

const LABEL = {
  [AdminEventsInput_Filter_HostedIn.ASSOCIATION]: 'Association',
  [AdminEventsInput_Filter_HostedIn.GROUPS]: 'Groups',
  [AdminEventsInput_Filter_HostedIn.SPONSORS]: 'Sponsors',
};

export const HostedInMenu: React.FC<{
  value?: AdminEventsInput_Filter_HostedIn;
  onChange: (value: AdminEventsInput_Filter_HostedIn) => void;
}> = ({ value, onChange }) => {
  return (
    <Menu>
      <MenuButton as={SelectButton}>{value ? LABEL[value] : 'All'}</MenuButton>
      <MenuList>
        <MenuOptionGroup type="radio" value={value ?? ''} onChange={onChange}>
          <MenuItemOption value="">All</MenuItemOption>
          <MenuItemOption value={AdminEventsInput_Filter_HostedIn.ASSOCIATION}>
            {LABEL[AdminEventsInput_Filter_HostedIn.ASSOCIATION]}
          </MenuItemOption>
          <MenuItemOption value={AdminEventsInput_Filter_HostedIn.GROUPS}>
            {LABEL[AdminEventsInput_Filter_HostedIn.GROUPS]}
          </MenuItemOption>
          <MenuItemOption value={AdminEventsInput_Filter_HostedIn.SPONSORS}>
            {LABEL[AdminEventsInput_Filter_HostedIn.SPONSORS]}
          </MenuItemOption>
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
};
